import { Login, SessionAction, authApi, authChannel } from "@/entities/session";
import { ApiResult, isErr, ok } from "@/shared/utils";
import { Dispatch, RefObject, useCallback } from "react";

export const useSessionAuthActions = (
    dispatch: Dispatch<SessionAction>,
    tokenRef: RefObject<string | null>
) => {
    const login = useCallback(async (payload: Login): Promise<ApiResult<void>> => {
        const sessionResult = await authApi.login(payload);
        if (isErr(sessionResult)) {
            dispatch({ type: 'AUTH_FAILURE' });
            return sessionResult;
        }

        const userResult = await authApi.getUserInfo();
        if (isErr(userResult)) {
            dispatch({ type: 'AUTH_FAILURE' });
            return userResult;
        }

        tokenRef.current = sessionResult.data.accessToken;
        dispatch({ type: 'AUTH_SUCCESS', user: userResult.data });
        
        return ok(undefined);
    }, []);

    const logout = useCallback(async () => {
        const { error } = await authApi.logout();
        if (error) console.warn('Logout API error:', error);
        tokenRef.current = null;
        dispatch({ type: 'LOGOUT' });
        authChannel.postMessage({ type: 'LOGOUT' });
    }, []);

    const refreshToken = useCallback(async (): Promise<string | null> => {
        const { data, error } = await authApi.refresh();
        if (error) { tokenRef.current = null; return null; }
        tokenRef.current = data.accessToken;
        return data.accessToken;
    }, []);

    return { login, logout, refreshToken };
};